<template>
  <v-row>
    <v-col cols="12" class="pa-0">
      <h4>Store Credit</h4>
    </v-col>

    <v-row class="align-center">
      <v-col cols="5" sm="7">
        $ {{ formatAmount(giftCardCreditBalance) }}
        <span class="d-none d-md-inline">Store Credit available</span>
      </v-col>

      <v-col cols="7" sm="5" class="text-sm-right pt-2">
        <v-btn
          block
          class="rounded text-uppercase bg-secondryButton text-white fontsize-14 checkout-page-btn checkout-product-button-height cart-products-button"
          size="large"
          density="comfortable"
          :rounded="0"
          :variant="isHovering ? 'outlined' : ''"
          v-bind="props"
          :disabled="!giftCardCreditBalance || isCheckoutProcessing"
          @click.prevent="useStoreCreditClick"
        >
          Use Store Credit</v-btn
        >
      </v-col>
    </v-row>
  </v-row>
</template>

<script>
import { formatAmount } from "@/services/util.service";
export default {
  name: "StoreCredit", // Name of the component for Vue
  props: ["giftCardCreditBalance", "isCheckoutProcessing"],
  computed: {},
  data() {
    return {};
  },

  methods: {
    formatAmount,
    useStoreCreditClick(item) {
      this.$emit("useStoreCreditClick", item);
    },
  },
};
</script>
<style lang="scss">
// end....
</style>
